module.exports = __webpack_public_path__ + "img/IT0004870844440.77bb3f1d.png";